"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requiredObject = exports.required = exports.rangeUnderflow = exports.rangeOverflow = exports.invalidNumber = exports.composeValidatorsWithArgs = exports.composeValidators = void 0;
var _reactIntl = require("react-intl");
var _FormattedKintMessage = _interopRequireDefault(require("../FormattedKintMessage"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const required = value => {
  const blankString = /^\s+$/;
  if (value && !blankString.test(value) || value === false || value === 0) {
    return undefined;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
    id: "stripes-core.label.missingRequiredField"
  });
};
exports.required = required;
const requiredObject = function () {
  let formValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // withKiwtFieldArray sets the _delete property on new objects by default
  // eslint-disable-next-line no-unused-vars
  const {
    _delete,
    ...value
  } = formValue;
  if (Object.keys(value).length === 0) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
      id: "stripes-core.label.missingRequiredField"
    });
  }
  return undefined;
};
exports.requiredObject = requiredObject;
const composeValidators = function () {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }
  return (value, allValues, meta) => validators.reduce((error, validator) => error || validator(value, allValues, meta), undefined);
};

// Similar to the above, but allow explicit setting of arguments to the validators
exports.composeValidators = composeValidators;
const composeValidatorsWithArgs = function () {
  for (var _len2 = arguments.length, validators = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    validators[_key2] = arguments[_key2];
  }
  return function () {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }
    return validators.reduce((error, validator) => error || validator(...args), undefined);
  };
};

// Make same shape as rangeOverflow/rangeUnderflow so we can combine them
exports.composeValidatorsWithArgs = composeValidatorsWithArgs;
const invalidNumber = function (value, _min, _max, intlKey, intlNS) {
  let labelOverrides = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
  if (!value && value !== 0) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedKintMessage.default, {
      id: "errors.invalidNumber",
      intlKey: intlKey,
      intlNS: intlNS,
      overrideValue: labelOverrides?.invalidNumberError
    });
  }
  return undefined;
};
exports.invalidNumber = invalidNumber;
const rangeOverflow = function (value, min, max, intlKey, intlNS) {
  let labelOverrides = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
  if ((value || value === 0) && value > max) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedKintMessage.default, {
      id: "errors.decimalValueNotInRange",
      intlKey: intlKey,
      intlNS: intlNS,
      overrideValue: labelOverrides?.decimalValueNotInRangeError,
      values: {
        min,
        max
      }
    });
  }
  return undefined;
};
exports.rangeOverflow = rangeOverflow;
const rangeUnderflow = function (value, min, max, intlKey, intlNS) {
  let labelOverrides = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
  if ((value || value === 0) && value < min) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedKintMessage.default, {
      id: "errors.decimalValueNotInRange",
      intlKey: intlKey,
      intlNS: intlNS,
      overrideValue: labelOverrides?.decimalValueNotInRangeError,
      values: {
        min,
        max
      }
    });
  }
  return undefined;
};
exports.rangeUnderflow = rangeUnderflow;